<template lang="pug">
    div
        Row
            Form(:model="form" :rules="validateRule")
                Col(v-for="(option, index) in options" :key="index")
                    FormItem
                        template(v-if="option.disabled")
                            Tooltip(:content="$t('global.systemDefault')" placement="right")
                                div.wafRateLimitTokenContainer
                                    Icon.iconWithPrimaryColor(type="md-checkmark")
                                span {{ option.label }}
                        template(v-else)
                            Checkbox(v-model="option.checked" @on-change="onChange") {{ option.label }}
                //- Col(style="padding-bottom: 12px")
                //-     FormItem(prop="customSignValue")
                //-         Input(placeholder="example" v-if="showInput()" v-model="form.customSignValue" @on-change="onChange" style="width: 200px")
        List(v-if="showWafRateLimitTokenPreview")
            ListItem
                ListItemMeta(:title="$t('wafrules.wafRateLimitTokenPreview')" :description="previewDescription()")
        Modal(
            v-model="showModal"
            :title="$t('global.reminderText')"
        )
            p {{ modalContent }}
            div(slot="footer")
                Button(type="default" @click="ok") OK
</template>
<script>
export default {
    name: "WafRateLimitTokenForm",
    props: {
        value: {
            default: () => {},
        },
        showWafRateLimitTokenPreview: {
            default: () => true,
        },
    },
    data() {
        return {
            deepCopyValueFromProps: {},
            rawOptions: [
                { value: "group", disabled: true, checked: false },
                { value: "ruleName", disabled: true, checked: false },
                { value: "ip", disabled: false, checked: false },
                { value: "host", disabled: false, checked: false },
                { value: "uri", disabled: false, checked: false },
                { value: "method", disabled: false, checked: false },
                { value: "country", disabled: false, checked: false },
                { value: "ua", disabled: false, checked: false },
                // { value: "customSign", disabled: false, checked: false },
            ],
            form: {
                // customSignValue: this.value.customSignValue,
            },
            validateRule: {
                // customSignValue: [
                //     {
                //         validator: (rule, value, callback) => {
                //             if (!value) {
                //                 return callback();
                //             }
                //             if (!/^[a-z0-9]*$/.test(value)) {
                //                 return callback(
                //                     new Error(`${this.$i18n.t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9`)
                //                 );
                //             }
                //             callback();
                //         },
                //         trigger: "blur",
                //     },
                // ],
            },
            showModal: false,
            modalContent: "",
        };
    },
    methods: {
        onChange() {
            // 當 ip 和 host 從 true 改為 false，需跳出 modal
            const checkKeyChangeFromTrueToFalse = (key) => {
                const option = this.options.find((option) => option.value == key);
                return this.deepCopyValueFromProps[key] && !option.checked;
            };
            const checkKeys = {
                ip: checkKeyChangeFromTrueToFalse("ip"),
                host: checkKeyChangeFromTrueToFalse("host"),
            };
            if (checkKeys.ip || checkKeys.host) {
                this.showModal = true;
                this.modalContent = this.$i18n.t(`wafrules.${checkKeys.ip ? "ip" : "host"}ChangeFromTrueToFalse`);
            }
            // emit data
            let emitData = {};
            this.options.forEach((option) => {
                emitData[option.value] = option.checked;
            });
            // emitData["customSignValue"] = this.form.customSignValue;
            this.$emit("input", emitData);
        },
        // showInput() {
        //     return this.options.find((option) => option.value == "customSign").checked;
        // },
        previewDescription() {
            return this.options
                .map((option) => {
                    if (!option.checked) return "-";
                    return this.$i18n.t(`wafrules.wafRateLimitTokenLabel.${option.value}`);
                })
                .join(",");
        },
        ok() {
            this.showModal = false;
        },
    },
    computed: {
        options() {
            this.deepCopyValueFromProps = JSON.parse(JSON.stringify(this.value));
            return this.rawOptions.map((item) => ({
                ...item,
                label: this.$i18n.t(`wafrules.wafRateLimitTokenLabel.${[item.value]}`),
                checked: this.deepCopyValueFromProps[item.value],
            }));
        },
    },
};
</script>

<style scoped>
    .wafRateLimitTokenContainer{
        display: inline-flex;
        width: 16px;
        align-items: center;
        justify-content: center;
        margin-right: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/components/FormItems/WafRateLimitTokenForm.vue